var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.78333 10.6967C3.58917 11.2167 3.425 11.6967 3.27833 12.1825C4.07833 11.6017 5.02917 11.2333 6.12667 11.0958C8.22083 10.8342 10.0817 9.45166 11.0233 7.71416L9.81 6.50166L10.9875 5.32249L11.8208 4.48832C12.1792 4.12999 12.5833 3.46832 13.0108 2.51499C8.35 3.23749 5.49583 6.09166 3.7825 10.6967H3.78333ZM12.1667 6.50082L13 7.33332C12.1667 9.83332 9.66667 12.3333 6.33333 12.75C4.10917 13.0283 2.72 14.5558 2.165 17.3333H0.5C1.33333 12.3333 3 0.666656 15.5 0.666656C14.6667 3.16416 13.835 4.82999 13.0025 5.66416L12.1667 6.50082Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.9421f2d68221e6566a1573cb737c0649.svg";
export { ForwardRef as ReactComponent };